export default {"src":"/_next/static/media/icon-stats-attack-speed.f200dca5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};